export default __webpack_public_path__ + "static/media/Rune Icon.5d7c7108.svg";